/** Shares owned + available subline for puts/calls/stocks screener tables. */

import { compactSubline } from "./webCompactMode";
import { fmtNum } from "./watchlistData";

export function renderScreenerSharesInnerHtml(
  shares: number | null | undefined,
  available: number | null | undefined,
): string {
  if (shares == null && available == null) return "—";
  const shareLabel = shares != null ? fmtNum(shares, 0) : "—";
  const avail = available ?? (shares != null ? 0 : null);
  const availLabel = avail != null ? fmtNum(avail, 0) : "—";
  const availCls = avail != null && avail > 0 ? "roi-strong" : "sfe-web-compact-sub";
  return `${shareLabel}${compactSubline(`avail ${availLabel}`, availCls)}`;
}

export function renderScreenerSharesCellHtml(
  shares: number | null | undefined,
  available: number | null | undefined,
  colId: string,
  esc: (value: string) => string = (value) => value,
): string {
  return `<td class="num sfe-shares-cell sfe-screener-shares-cell" data-col="${esc(colId)}">${renderScreenerSharesInnerHtml(shares, available)}</td>`;
}

export function paintScreenerSharesCell(
  cell: HTMLTableCellElement,
  shares: number | null | undefined,
  available: number | null | undefined,
): void {
  cell.classList.add("num", "sfe-shares-cell", "sfe-screener-shares-cell");
  cell.innerHTML = renderScreenerSharesInnerHtml(shares, available);
}

export function parseSharesColumnAvailable(cell: HTMLTableCellElement | null): number | null {
  if (!cell) return null;
  for (const sub of cell.querySelectorAll("small")) {
    const match = (sub.textContent ?? "").trim().match(/^avail\s+([\d,]+)/i);
    if (match) return Number(match[1].replace(/,/g, ""));
  }
  for (const line of cell.querySelectorAll(".held-line")) {
    const label = line.querySelector(".held-k")?.textContent?.trim().toLowerCase();
    if (label !== "avail") continue;
    const match = (line.textContent ?? "").trim().match(/^(\d+)/);
    return match ? Number(match[1]) : 0;
  }
  return null;
}
